import styled, { css, keyframes } from 'styled-components';
const appearIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const appearOut = keyframes(["100%{opacity:0;}0%{opacity:1;}"]);
const appearInAnimation = css(["animation:", " 0.25s ease-in;"], appearIn);
const appearOutAnimation = css(["animation:", " 0.25s ease-in;"], appearOut);
const slideIn = keyframes(["0%{transform:translateX(-125%);}100%{transform:translateX(0);}"]);
const slideOut = keyframes(["100%{transform:translateX(-125%);}0%{transform:translateX(0);}"]);
const slideInAnimation = css(["animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);"], slideIn);
const slideOutAnimation = css(["animation:", " 0.3s cubic-bezier(0.49,0.42,0.52,0.98);"], slideOut);
export const Inner = styled.nav.withConfig({
  displayName: "Menu__Inner",
  componentId: "sc-1wx3xa6-0"
})(["display:", ";"], _ref => {
  let {
    showMenu
  } = _ref;
  return showMenu ? 'block' : 'none';
});
export const MenuBackground = styled.div.withConfig({
  displayName: "Menu__MenuBackground",
  componentId: "sc-1wx3xa6-1"
})(["position:fixed;z-index:900;top:", "px;bottom:0;left:0;width:100vw;background-color:rgba(0,0,0,0.75);", ";animation-fill-mode:forwards;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.mobileNavHeight;
}, _ref3 => {
  let {
    animate
  } = _ref3;
  return animate ? appearOutAnimation : appearInAnimation;
});
export const Menu = styled.div.withConfig({
  displayName: "Menu",
  componentId: "sc-1wx3xa6-2"
})(["display:flex;flex-direction:column;position:fixed;z-index:900;top:", "px;bottom:0;left:0;width:100%;overflow:auto;-webkit-overflow-scrolling:touch;box-shadow:0 15px 35px rgba(34,34,90,0.1),0 5px 15px rgba(0,0,0,0.07),0 1px 3px 1px rgba(34,34,90,0.07);background-color:#fff;", ";animation-fill-mode:forwards;"], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.mobileNavHeight;
}, _ref5 => {
  let {
    animate
  } = _ref5;
  return animate ? slideOutAnimation : slideInAnimation;
});
export const MenuContent = styled.div.withConfig({
  displayName: "Menu__MenuContent",
  componentId: "sc-1wx3xa6-3"
})(["margin-top:0;"]);
export const Separator = styled.div.withConfig({
  displayName: "Menu__Separator",
  componentId: "sc-1wx3xa6-4"
})(["width:92%;padding:8px 0;margin:0 auto;"]);